// extracted by mini-css-extract-plugin
export var LogoContainer = "Logo-module--LogoContainer--30yzA";
export var LogoImage = "Logo-module--LogoImage--3_zli";